export default __webpack_public_path__ + "static/media/icon-right.10185590.svg";